// extracted by mini-css-extract-plugin
export default {"x-micro-small":"10px","micro-small":"12px","small":"14px","normal":"16px","big":"18px","bigger":"24px","Hbigger":"26px"};